import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDraftCreated = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 7H17V9L16 14L15 9H9V15L14 16L9 17H7V7Z",
			fill: "currentColor",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.5,
			y: 14.5,
			width: 3,
			height: 3,
			rx: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.5,
			y: 6.5,
			width: 3,
			height: 3,
			rx: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 6,
			width: 4,
			height: 4,
			rx: 2,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDraftCreated);
export { ForwardRef as ReactComponent };
